import type { FC } from 'react';

import { withProps } from 'recompact';

import About from 'src/app/components/Pages/About';
import { AccountCreationSuccess } from 'src/app/components/Pages/AccountCreationSuccess';
import { AccountPageAddAddress } from 'src/app/components/Pages/AccountPage/Add/Address';
import AccountPageAddCreditCard from 'src/app/components/Pages/AccountPage/Add/CreditCard/container';
import AccountPageAddDependent from 'src/app/components/Pages/AccountPage/Add/FamilyMember/container';
import { AccountPageAddInsurance } from 'src/app/components/Pages/AccountPage/Add/Insurance';
import { AccountPage } from 'src/app/components/Pages/AccountPage/container';
import { AccountPageUpdatePhone } from 'src/app/components/Pages/AccountPage/UpdatePhone/index';
import { ArchivedPrescriptions } from 'src/app/components/Pages/ArchivedPrescriptions/index';
import AccountSetup from 'src/app/components/Pages/Checkout/Account/container';
import AccountUploadID from 'src/app/components/Pages/Checkout/AccountUploadID/container';
import { AllergyProfile } from 'src/app/components/Pages/Checkout/AllergyProfile/container';
import { CheckoutContactInfo } from 'src/app/components/Pages/Checkout/ContactInfo/container';
import CheckoutPage from 'src/app/components/Pages/Checkout/container';
import DeliveryAddressCreate from 'src/app/components/Pages/Checkout/DeliveryAddress/Create/container';
import { DeliveryAddressSelect } from 'src/app/components/Pages/Checkout/DeliveryAddress/Select/index';
import DeliveryItems from 'src/app/components/Pages/Checkout/DeliveryItems/container';
import DeliveryMethodSelect from 'src/app/components/Pages/Checkout/DeliveryMethods/container';
import { RescheduleDeliveryWindow } from 'src/app/components/Pages/Checkout/DeliveryWindow/Reschedule';
import DeliveryWindowSelect from 'src/app/components/Pages/Checkout/DeliveryWindow/Select/container';
import { MedicalHistoryForm } from 'src/app/components/Pages/Checkout/MedicalHistory/MedicalHistory';
import PaymentCardCreate from 'src/app/components/Pages/Checkout/PaymentCard/Create/container';
import { PaymentCardSelect } from 'src/app/components/Pages/Checkout/PaymentCard/Select/index';
import { PickupStationSelect } from 'src/app/components/Pages/Checkout/PickupStation';
import { HubInvalidCode } from 'src/app/components/Pages/ClearRx/HubInvalidCode';
import { HubNotFound } from 'src/app/components/Pages/ClearRx/NotFound';
import { PharmacyHubDemoTrigger } from 'src/app/components/Pages/ClearRx/PharmacyHubDemo/PharmacyHubDemoTrigger/index';
import { PharmacyHubDemoJourney } from 'src/app/components/Pages/ClearRx/PharmacyHubDemo/PharmacyHubJourney/index';
import { ClearRxSelect } from 'src/app/components/Pages/ClearRx/PharmacySelection';
import { ClearRxShortCodeRedirect } from 'src/app/components/Pages/ClearRx/ShortCodeRedirect';
import Contact from 'src/app/components/Pages/Contact/container';
import Doctors from 'src/app/components/Pages/Doctors';
import { EducationalTellYourDoctor } from 'src/app/components/Pages/EducationalTellYourDoctor';
import EmployeeBenefitsPage from 'src/app/components/Pages/EmployeeBenefits/container';
import { LoadOnboardingStep } from 'src/app/components/Pages/EscriptOnboarding';
import { CheckoutAddons } from 'src/app/components/Pages/Essentials/CheckoutAddons';
import { EssentialsCategory } from 'src/app/components/Pages/Essentials/EssentialsCategory/index';
import { Essentials } from 'src/app/components/Pages/Essentials/index';
import FaqPage from 'src/app/components/Pages/Faq/container';
import { GetStartedPage } from 'src/app/components/Pages/GetStarted/container';
// New get started pages:
import { GetStartedNew } from 'src/app/components/Pages/GetStartedNew/index';
import { CaptchaStep as GetStartedNewCaptchaStep } from 'src/app/components/Pages/GetStartedNew/Steps/CaptchaStep/index';
import { ContactStep as GetStartedNewContactStep } from 'src/app/components/Pages/GetStartedNew/Steps/ContactStep/index';
import { Waitlist as GetStartedNewWaitlist } from 'src/app/components/Pages/GetStartedNew/Steps/Waitlist/index';
import { WaitlistConfirmation as GetStartedNewWaitlistConfirmation } from 'src/app/components/Pages/GetStartedNew/Steps/WaitlistConfirmation/index';
import { Hipaa } from 'src/app/components/Pages/Hipaa';
import HowItWorks from 'src/app/components/Pages/HowItWorks/container';
import Locations from 'src/app/components/Pages/Locations/container';
import LoggedInTransferConfirm from 'src/app/components/Pages/LoggedInTransfer/Confirm';
import { LoggedInTransferForm } from 'src/app/components/Pages/LoggedInTransfer/Experiment';
import LoggedInTransferFAQ from 'src/app/components/Pages/LoggedInTransfer/FAQ/container';
import { PostOrderNextSessionInterstitial } from 'src/app/components/Pages/LoggedInTransfer/PostOrderNextSessionInterstitial';
import { PostOrderPrompt } from 'src/app/components/Pages/LoggedInTransfer/PostOrderPrompt';
import { Login } from 'src/app/components/Pages/Login';
import { Logout } from 'src/app/components/Pages/Logout';
import { MedicationDetails } from 'src/app/components/Pages/MedicationDetails';
import Medications from 'src/app/components/Pages/Medications/container';
import { MFAForm } from 'src/app/components/Pages/MFA/MFAForm';
import { MFAInterstitial } from 'src/app/components/Pages/MFA/MFAInterstitial';
import NotFound from 'src/app/components/Pages/NotFound';
import { RescheduleOrder } from 'src/app/components/Pages/Order/FailedOrderReschedule';
import { OrderHistory } from 'src/app/components/Pages/Order/History/container';
import { OrderTracking } from 'src/app/components/Pages/Order/Tracking/container';
import { OrderTrackingRedirect } from 'src/app/components/Pages/Order/TrackingRedirect/trackingRedirect';
import { PartnerOnboardingFlow } from 'src/app/components/Pages/PartnerOnboardingFlow/container';
import ChangePassword from 'src/app/components/Pages/Password/Change/container';
import ResetPassword from 'src/app/components/Pages/Password/Reset/index';
import { PasswordResetRequired } from 'src/app/components/Pages/Password/ResetRequired';
import { PasswordResetSuccess } from 'src/app/components/Pages/Password/ResetSuccess';
import { PrivacyPolicy } from 'src/app/components/Pages/PrivacyPolicy';
import { PromoOnboardingSteps } from 'src/app/components/Pages/PromoOnboardingSteps/container';
import { PromoOnboardingWaitlist } from 'src/app/components/Pages/PromoOnboardingWaitlist/container';
import { PromoOnboardingWaitlistSuccess } from 'src/app/components/Pages/PromoOnboardingWaitlistSuccess';
import { MultiReferralPromo } from 'src/app/components/Pages/PromotionalLandingPage/constants';
import { PromotionalLandingPage } from 'src/app/components/Pages/PromotionalLandingPage/container';
import { RedirectToPromoPage } from 'src/app/components/Pages/PromotionalLandingPage/RedirectToPromoPage/container';
import { ShowYourDoctor } from 'src/app/components/Pages/ShowYourDoctor/container';
import { TermsConditions } from 'src/app/components/Pages/TermsConditions';
import UrlProxy from 'src/app/components/Pages/UrlShortener/sendToApi';
import ValidateAddress from 'src/app/components/Pages/ValidateAddress/container';
import { ValidateAddressV2 } from 'src/app/components/Pages/ValidateAddress/validateAddressV2';
import { ZipCodeCheckPage } from 'src/app/components/Pages/ZipCodeCheck/container';
import { BrandedMedicationGuide } from 'src/app/components/PageSections/BrandedMedicationGuide/container';
import { requiresCartPresent } from 'src/app/hocs/checkout/requiresCartPresent';
import { requiresInCheckout } from 'src/app/hocs/checkout/requiresInCheckout';
import { Checkout } from 'src/app/layouts/Checkout/container';
import { I18nNative } from 'src/app/layouts/I18nNative';
import { LoggedIn } from 'src/app/layouts/LoggedIn/container';
import { Marketing } from 'src/app/layouts/Marketing/container';
import { Native } from 'src/app/layouts/Native';
import { Promotional } from 'src/app/layouts/Promotional/container';

import { HealthProfileUpdateComponent } from '../components/Pages/HealthProfileUpdate';
import { OpenAppLanding } from '../components/Pages/OpenAppLanding';
import { UpdatePhoneSuccessPage } from '../components/Pages/SuccessPage';
import { WithInsuranceRedirect } from '../components/Pages/UrlShortener/WithInsuranceRedirect';

import * as paths from './paths';
import { setPreservedQueryParameters } from './utils';

/**
 * ROUTE SHAPE
 *
 * {
 *   path,
 *   exact, // optional
 *   layout, // layout component
 *   components, // components layout accepts
 * }
 *
 */
export type Route = {
  path?: string;
  layout: FC;
  components: { content: FC };
  title: string;
  exact?: boolean;
  isAuthenticated?: boolean;
};

export type RedirectedRoute = {
  redirect: boolean;
  to: string;
  from: string;
  queryParams: string;
};

const routes: (Route | RedirectedRoute)[] = [
  {
    path: paths.welcome.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountCreationSuccess,
    },
    title: 'Account successfully created | Capsule',
  },
  {
    path: paths.about.route,
    exact: true,
    layout: Marketing,
    components: {
      content: About,
    },
    title: 'About us | Capsule',
  },
  {
    path: paths.locations.route,
    exact: true,
    layout: Marketing,
    components: {
      content: Locations,
    },
    title: 'Locations | Capsule',
  },
  {
    path: paths.doctors.route,
    exact: true,
    layout: Marketing,
    components: {
      content: Doctors,
    },
    title: 'For doctors | Capsule',
  },
  {
    path: paths.howItWorks.route,
    exact: true,
    layout: Marketing,
    components: {
      content: HowItWorks,
    },
    title: 'How it works | Capsule',
  },
  {
    path: paths.getStarted.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedPage,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.getStartedNew.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedNew,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.getStartedNewWaitlist.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedNewWaitlist,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.getStartedNewWaitlistConfirmation.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedNewWaitlistConfirmation,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.getStartedNewContact.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedNewContactStep,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.getStartedNewCaptcha.route,
    exact: true,
    layout: Marketing,
    components: {
      content: GetStartedNewCaptchaStep,
    },
    title: 'Check if we deliver to you | Capsule',
  },
  {
    path: paths.termsAndConditions.route,
    exact: true,
    layout: Marketing,
    components: {
      content: TermsConditions,
    },
    title: 'Terms of Service | Capsule',
  },
  {
    path: paths.hipaa.route,
    exact: true,
    layout: Marketing,
    components: {
      content: Hipaa,
    },
    title: 'HIPAA Privacy | Capsule',
  },
  {
    path: paths.privacy.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PrivacyPolicy,
    },
    title: 'Privacy Policy | Capsule',
  },
  /**
   * @deprecated
   * The /faq path has been replaced with /questions
   */
  {
    path: paths.faq.route,
    exact: true,
    layout: Marketing,
    components: {
      content: FaqPage,
    },
    title: 'FAQ | Capsule',
  },
  {
    path: paths.questions.route,
    exact: true,
    layout: Marketing,
    components: {
      content: FaqPage,
    },
    title: 'Questions | Capsule',
  },
  /**
   * @deprecated
   * The /rx/faq path has been replaced with /rx/questions
   */
  {
    path: paths.loggedInFAQ.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: FaqPage,
    },
    title: 'FAQ | Capsule',
  },
  {
    path: paths.loggedInQuestions.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: FaqPage,
    },
    title: 'Questions | Capsule',
  },
  {
    path: paths.login.route,
    exact: true,
    layout: Marketing,
    components: {
      content: Login,
    },
    title: 'Login | Capsule',
  },
  {
    path: paths.openAppLanding.route,
    exact: true,
    layout: Native,
    components: {
      content: OpenAppLanding,
    },
    title: 'Open App | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.mfaInterstitial.route,
    exact: true,
    layout: Marketing,
    components: {
      content: MFAInterstitial,
    },
    title: 'We sent you a text | Capsule',
  },
  {
    path: paths.mfaForm.route,
    exact: true,
    layout: Marketing,
    components: {
      content: MFAForm,
    },
    title: 'Enter your code | Capsule',
  },
  {
    path: paths.passwordResetRequired.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PasswordResetRequired,
    },
    title: 'Password reset required | Capsule',
  },
  {
    path: paths.forgotPassword.route,
    exact: true,
    layout: Marketing,
    components: {
      content: ResetPassword,
    },
    title: 'Forgot your password | Capsule',
  },
  {
    path: paths.forgotPasswordSuccess.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PasswordResetSuccess,
    },
    title: 'Password reset email sent | Capsule',
  },
  {
    /**
     * @deprecated - This method of pw reset is no longer supported
     * @todo
     * Delete this and any relevant source code after mapping this to a Next.js redirect instead.
     * By doing so, we'll decrease the bundle a wee tiny bit.
     *
     * @see https://nextjs.org/docs/api-reference/next.config.js/rewrites
     */
    path: paths.resetPassword.route,
    exact: true,
    layout: Marketing,
    components: {
      content: ResetPassword,
    },
    title: 'Forgot your password | Capsule',
  },
  {
    path: paths.resetPasswordWithApiKey.route,
    exact: true,
    layout: Marketing,
    components: {
      content: ChangePassword,
    },
    title: 'Update your password | Capsule',
  },
  {
    path: paths.medications.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: Medications,
    },
    title: 'Prescriptions | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.newOnboardingStep.route,
    exact: true,
    layout: Marketing,
    components: {
      content: LoadOnboardingStep,
    },
    title: 'Welcome | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.shop.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: Essentials,
    },
    title: 'Over-the-counter essentials | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.shop2.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: Essentials,
    },
    title: 'Over-the-counter essentials | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.shop2Category.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: EssentialsCategory,
    },
    title: 'Over-the-counter essentials | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.partnerOnboardingFlow.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: PartnerOnboardingFlow,
    },
    title: 'Claim your account | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAddons.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: CheckoutAddons,
    },
    title: 'Checkout addons | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkout.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresCartPresent(CheckoutPage),
    },
    title: 'Checkout | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutSelectAddress.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(DeliveryAddressSelect),
    },
    title: 'Choose delivery address | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutSelectPickupStation.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(PickupStationSelect),
    },
    title: 'Choose your pickup location | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAddAddress.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(DeliveryAddressCreate),
    },
    title: 'Add delivery address | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutSelectWindow.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(DeliveryWindowSelect),
    },
    title: 'Choose a Delivery Window | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutSelectDeliveryMethod.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(DeliveryMethodSelect),
    },
    title: 'Choose a delivery method | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutSelectCreditCard.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(PaymentCardSelect),
    },
    title: 'Select a credit card | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAddCreditCard.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(PaymentCardCreate),
    },
    title: 'Add a credit card | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutContactInfo.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(CheckoutContactInfo),
    },
    title: 'Contact info | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAllergyProfile.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(AllergyProfile),
    },
    title: 'Allergy and Medical Profile | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutMedicalHistory.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(MedicalHistoryForm),
    },
    title: 'Medical history and other medications | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAddIdentification.route,
    exact: true,
    layout: Checkout,
    components: {
      content: AccountUploadID,
    },
    title: 'Add ID photo | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.checkoutAccountSetup.route,
    exact: true,
    layout: Checkout,
    components: {
      content: requiresInCheckout(AccountSetup),
    },
    title: 'Create an account | Capsule',
    isAuthenticated: true,
  },
  // Viewing items during Checkout
  {
    path: paths.checkoutCartItems.route,
    exact: true,
    layout: Checkout,
    components: {
      content: withProps({ isInCheckout: true })(DeliveryItems),
    },
    title: 'Order details | Capsule',
    isAuthenticated: true,
  },
  // Viewing items post Checkout, when an Order has been created
  {
    path: paths.checkoutOrderItems.route,
    exact: true,
    layout: Checkout,
    components: {
      content: DeliveryItems,
    },
    title: 'Order details | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.validateAddress.route,
    exact: true,
    layout: Checkout,
    components: {
      content: ValidateAddress,
    },
    title: 'Verify your address | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.validateAddressV2.route,
    exact: true,
    layout: Checkout,
    components: {
      content: ValidateAddressV2,
    },
    title: 'Verify your address | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.orderStatusDeepLink.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: OrderTrackingRedirect,
    },
    title: 'Redirect to order tracking | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.accountPage.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPage,
    },
    title: 'Your account | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPageAddDependent.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPageAddDependent,
    },
    title: 'Add a family member | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPageAddAddress.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPageAddAddress,
    },
    title: 'Add a delivery address | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPageInsurance.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPageAddInsurance,
    },
    title: 'Add insurance | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPageCreditCard.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPageAddCreditCard,
    },
    title: 'Add a credit card | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPagePhone.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: AccountPageUpdatePhone,
    },
    title: 'Update phone number | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.AccountPagePhoneUpdateSuccess.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: UpdatePhoneSuccessPage,
    },
    title: 'Update phone number | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.orderItems.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: DeliveryItems,
    },
    title: 'Order items | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInTransferRx.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: LoggedInTransferForm,
    },
    title: 'Transfer a prescription | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInTransferPostOrderPrompt.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: PostOrderPrompt,
    },
    title: 'Transfer medications? | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInTransferAppInterstitialPrompt.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: PostOrderNextSessionInterstitial,
    },
    title: 'Transfer medications? | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInHealthProfile.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: HealthProfileUpdateComponent,
    },
    title: 'Health Profile Update | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.tellYourDoctor.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: EducationalTellYourDoctor,
    },
    title: 'Tell your doctor | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInPromoOnboardingPage.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PromoOnboardingSteps,
    },
    title: 'Transfer a prescription | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedOutPromoOnboardingWaitlist.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PromoOnboardingWaitlist,
    },
    title: 'Waiting list | Capsule',
  },
  {
    path: paths.loggedOutPromoOnboardingWaitlistSuccess.route,
    exact: true,
    layout: Marketing,
    components: {
      content: PromoOnboardingWaitlistSuccess,
    },
    title: 'Waiting list success | Capsule',
  },
  {
    path: paths.loggedInTransferRxSuccess.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: LoggedInTransferConfirm,
    },
    title: 'Transfer submitted | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedInTransferFAQ.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: LoggedInTransferFAQ,
    },
    title: 'Transfer FAQ | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.orders.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: OrderHistory,
    },
    title: 'Your orders | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.orderTracking.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: OrderTracking,
    },
    title: 'Order tracking | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.rescheduleDeliveryWindows.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: RescheduleDeliveryWindow,
    },
    title: 'Reschedule delivery window | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.rescheduleOrder.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: RescheduleOrder,
    },
    title: 'Reschedule verification | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.archivedPrescriptions.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: ArchivedPrescriptions,
    },
    title: 'Archived prescriptions | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.contact.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: Contact,
    },
    title: 'Contact us | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.showYourDoctor.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: ShowYourDoctor,
    },
    title: 'Pharmacy information | Capsule',
    isAuthenticated: true,
  },
  {
    path: paths.loggedOutShowYourDoctor.route,
    exact: true,
    layout: Marketing,
    components: {
      content: ShowYourDoctor,
    },
    title: 'Pharmacy information | Capsule',
  },
  {
    path: paths.medicationDetails.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: MedicationDetails,
    },
    title: 'Medication details | Capsule',
  },
  {
    path: paths.medicationDetailsForTransfer.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: MedicationDetails,
    },
    title: 'Medication details for transfer | Capsule',
  },
  {
    path: paths.medicationGuides.route,
    exact: true,
    layout: LoggedIn,
    components: {
      content: BrandedMedicationGuide,
    },
    title: 'Medication guides | Capsule',
  },
  {
    path: paths.notFound.route,
    layout: Marketing,
    components: {
      content: NotFound,
    },
    title: 'Page not found | Capsule',
  },
  {
    path: paths.logout.route,
    layout: Marketing,
    components: {
      content: Logout,
    },
    title: 'Login | Capsule',
  },
  {
    path: paths.nativeFaq.route,
    layout: Native,
    components: {
      content: FaqPage,
    },
    title: 'FAQ | Capsule',
  },
  {
    path: paths.pharmacyHubTriggerDemo.route,
    layout: I18nNative,
    components: {
      content: PharmacyHubDemoTrigger,
    },
    title: 'Pharmacy Hub Demo',
  },
  {
    path: paths.spanishPharmacyHubTriggerDemo.route,
    layout: I18nNative,
    components: {
      content: PharmacyHubDemoTrigger,
    },
    title: 'Demo de Pharmacy Hub',
  },
  {
    path: paths.pharmacyHubJourney.route,
    layout: I18nNative,
    components: {
      content: PharmacyHubDemoJourney,
    },
    title: 'Pharmacy Hub Demo',
  },
  {
    path: paths.spanishPharmacyHubJourney.route,
    layout: I18nNative,
    components: {
      content: PharmacyHubDemoJourney,
    },
    title: 'Demo de Pharmacy Hub',
  },
  {
    path: paths.nativeTerms.route,
    layout: Native,
    components: {
      content: TermsConditions,
    },
    title: 'Terms of service | Capsule',
  },
  {
    path: paths.nativeHipaa.route,
    layout: Native,
    components: {
      content: Hipaa,
    },
    title: 'HIPAA privacy | Capsule',
  },
  {
    path: paths.nativeMedicationGuides.route,
    layout: Native,
    components: {
      content: BrandedMedicationGuide,
    },
    title: 'Medication guides | Capsule',
  },
  {
    path: paths.nativePrivacy.route,
    layout: Native,
    components: {
      content: PrivacyPolicy,
    },
    title: 'Privacy | Capsule',
  },
  {
    path: paths.nativeShowYourDoctor.route,
    layout: Native,
    components: {
      content: ShowYourDoctor,
    },
    title: 'Pharmacy information | Capsule',
  },
  {
    path: paths.PromotionalLandingPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: PromotionalLandingPage,
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.flexdeliveryRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: MultiReferralPromo.flexdelivery })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.devotedRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'devoted' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.CignaRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'cigna' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.CCARedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'cca' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.MorganStanleyRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'morganstanley' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.ChicagoTransitRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'chicagotransit' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.EHEHealthRedirectToPromoPage.route,
    exact: true,
    layout: Promotional,
    components: {
      content: withProps({ promoCode: 'ehehealth' })(RedirectToPromoPage),
    },
    title: 'Get started | Capsule - Free prescription delivery',
  },
  {
    path: paths.checkZipCode.route,
    exact: true,
    layout: Promotional,
    components: {
      content: ZipCodeCheckPage,
    },
    title: 'Zip code delivery check',
  },
  {
    path: paths.checkProviderZipCode.route,
    exact: true,
    layout: Promotional,
    components: {
      content: ZipCodeCheckPage,
    },
    title: 'Zip code delivery check for providers',
  },
  {
    path: paths.employeeBenefitsPage.route,
    layout: LoggedIn,
    components: {
      content: EmployeeBenefitsPage,
    },
    title: 'Capsule | Employee benefits',
    isAuthenticated: true,
  },
  {
    path: paths.urlShortener.route,
    layout: Native,
    components: {
      content: UrlProxy,
    },
    title: 'Redirect to order tracking | Capsule',
  },
  {
    path: paths.redirectToInsurance.route,
    layout: Native,
    components: {
      content: WithInsuranceRedirect,
    },
    title: 'Redirect to insurance upload | Capsule',
  },
  // Pharmacy Hub Pages
  {
    path: paths.clearRxSelect.route,
    layout: I18nNative,
    components: {
      content: ClearRxSelect,
    },
    title: 'ClearRx',
  },
  {
    path: paths.spanishClearRxSelect.route,
    layout: I18nNative,
    components: {
      content: ClearRxSelect,
    },
    title: 'ClearRx',
  },
  {
    path: paths.clearRxNotFound.route,
    layout: I18nNative,
    components: {
      content: HubNotFound,
    },
    title: 'Page Not Found | ClearRx',
  },
  {
    path: paths.spanishClearRxNotFound.route,
    layout: I18nNative,
    components: {
      content: HubNotFound,
    },
    title: 'Página No Encontrada | ClearRx',
  },
  {
    path: paths.clearRxInvalidCode.route,
    layout: I18nNative,
    components: {
      content: HubInvalidCode,
    },
    title: 'Invalid | ClearRx',
  },
  {
    path: paths.spanishClearRxInvalidCode.route,
    layout: I18nNative,
    components: {
      content: HubInvalidCode,
    },
    title: 'Inválido | ClearRx',
  },
  {
    path: paths.clearRxShortCodeProxy.route,
    layout: I18nNative,
    components: {
      content: ClearRxShortCodeRedirect,
    },
    title: 'Redirect Code | ClearRx',
  },
  {
    path: paths.spanishClearRxShortCodeProxy.route,
    layout: I18nNative,
    components: {
      content: ClearRxShortCodeRedirect,
    },
    title: 'Código de Redirección | ClearRx',
  },
  {
    path: paths.clearRxPrivacy.route,
    layout: Native,
    components: {
      content: withProps({ isClearRxPage: true })(PrivacyPolicy),
    },
    title: 'Privacy Policy | ClearRx',
  },
  {
    path: paths.clearRxTerms.route,
    layout: Native,
    components: {
      content: withProps({ isClearRxPage: true })(TermsConditions),
    },
    title: 'Terms of Service | ClearRx',
  },
  {
    path: paths.clearRxHIPAA.route,
    layout: Native,
    components: {
      content: Hipaa,
    },
    title: 'HIPAA Policy | ClearRx',
  },
  {
    // 404 route
    layout: Marketing,
    components: {
      content: NotFound,
    },
    title: 'Page not found | Capsule',
  },
  {
    redirect: true,
    to: paths.loggedInTransferRx.route,
    from: paths.loggedInTransferRxDeprecated.route,
    queryParams: setPreservedQueryParameters(
      'utm_campaign',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      '_branch_match_id'
    ),
  },
  {
    redirect: true,
    to: paths.loggedInTransferRx.route,
    from: paths.loggedInTransferPrompt.route,
    queryParams: setPreservedQueryParameters(
      'utm_campaign',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      '_branch_match_id'
    ),
  },
];

export const layouts = { Marketing, Checkout, Promotional, LoggedIn, Native, I18nNative };

// eslint-disable-next-line import/no-default-export
export default routes;
